export { default as Modal } from './Modal';
export type { Props as ModalProps } from './Modal';
